import { TenantFlightSteps } from "@tenant/types";

export const MULTICITY_STEP_IDS: TenantFlightSteps[] = [
  TenantFlightSteps.MULTICITY_DEPARTURE0,
  TenantFlightSteps.MULTICITY_DEPARTURE1,
  TenantFlightSteps.MULTICITY_DEPARTURE2,
  TenantFlightSteps.MULTICITY_DEPARTURE3,
  TenantFlightSteps.MULTICITY_DEPARTURE4,
];
